export const ocpColorsArr = [
  '#e1f9fe', // 0
  '#cae3f4', // 1
  '#b2cdea', // 2
  '#9bb6df', // 3
  '#83a0d5', // 4
  '#6c8acb', // 5
  '#5474c1', // 6
  '#3e5db6', // 7
  '#2647ac', // 8
  '#0e31a2', // 9
  '#0b226c', // 10
];

export const heatmapColorsArr = [
  '#c70900', // 0
  '#da3301', // 1
  '#e06600', // 2
  '#E08000', // 3
  '#E0C000', // 4
  '#E0E000', // 5
  '#C0E000', // 6
  '#95f000', // 7
  '#00FF00', // 8
  '#36ff36', // 9
];

// export const insightsMapColorsArr = [
//   "#19a439", // green
//   "#e74221", // red
//   "#0af0ed", // tourquise
// ];

export const insightsMapColorsArr = {
  insight0: '#5df780',
  insight1: '#19a439',
  insight2: '#e74221',
  insight3: '#0af0ed',
  insight4: '#e74221',
  insight5: '#ca715f',
  insight6: '#e74221',
  insight7: '#0af0ed',
  insight8: '#e74221',
  insight9: '#e74221',
  insight10: '#0af0ed',
  insight11: '#f7775d',
  insight12: '#ca715f',
  insight13: '#f7775d',
};

export const brandColors = {
  PURPLE: '#f9dfff',
  NULL: '#acacac',
  BLUE: '#3244E2',
  BLUE_LIGHT: '#3244E220',
  TURQUOISE: '#00E0EB',
  TURQUOISE_LIGHT: '#00E0EB20',
  GREY: '#A6A8AB',
  GREY_LIGHT: '#A6A8AB20',
  GREY_DARK: '#6a6a6a',
  RED: '#BE1E2D',
  YELLOW: '#FCB400',
  ORANGE: '#fc7e00',
  GREEN: '#00A551',
  BLACK: '#000',
  BLUE_LIGHT_SECONDARY: '#3244E220',
  TURQUOISE_LIGHT_SECONDARY: '#00E0EB20',
  GREY_LIGHT_SECONDARY: '#A6A8AB20',
  FILTER_BAR: '#DEE4F9',
  GREEN_LIGHT: '#e3ffde',
  GREEN_DARK: '#005e15',
  YELLOW_LIGHT: '#fffbda',
  YELLOW_DARK: '#6e6000',
  RED_LIGHT: '#ffdcdc',
  RED_DARK: '#660000',
};

export const currDataColors = {
  GREEN_LIGHT: '#e3ffde',
  GREEN_DARK: '#005e15',
  YELLOW_LIGHT: '#fffbda',
  YELLOW_DARK: '#6e6000',
  RED_LIGHT: '#ffdcdc',
  RED_DARK: '#660000',
};
